import styled from 'styled-components';
import { Row, media, Column } from '@simplywallst/ui-core';

export const BrandingWrapper = styled(Column)`
  background: ${({ theme }) => theme.color.white};
  height: ${({ theme }) => theme.desktopTopbarHeight}px;
  position: relative;
  ${media.mdDown`
		display: none;
	`};
`;
export const BrandingContent = styled('div')`
  width: 1200px;
  padding: 0 ${({ theme }) => theme.x2spacePx}px;
`;
export const ImageLogo = styled('img')`
  height: ${({ theme }) => theme.desktopTopbarHeight}px;
  padding: ${({ theme }) => theme.x1spacePx}px 0;
`;
export const PoweredByWrapper = styled(Row)`
  height: ${({ theme }) => theme.x8spacePx}px;
`;
export const SWSLogoBlackWrapper = styled('div')`
  margin-left: ${({ theme }) => theme.x1spacePx}px;
  margin-bottom: ${({ theme }) => theme.x1spacePx - 5}px;
  svg {
    width: ${({ theme }) => theme.x16spacePx}px;
    height: ${({ theme }) => theme.x3spacePx + 5}px;
  }
`;
